/// <reference path="../../vendor/angular/angular.js" />
'use strict';

angular.module('userRequestEditControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'helpers.array',
    'services.search'
]);